import { render, staticRenderFns } from "./ProLoginPage.vue?vue&type=template&id=c2c858c0"
import script from "./ProLoginPage.vue?vue&type=script&lang=js"
export * from "./ProLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports